'use client'

import { OverlayShowSizesButton } from 'product-card/components/shared/OverlayContent/OverlayShowSizesButton/OverlayShowSizesButton'
import { OverlaySizesSheetButton } from 'product-card/components/shared/OverlayContent/OverlaySizesSheetButton/OverlaySizesSheetButton'
import { useResponsive } from 'responsive/hooks/useResponsive/useResponsive'

import styles from './OverlayAddToBag.module.css'

export function OverlayAddToBag() {
	const { isLargeOrGreater } = useResponsive()

	return isLargeOrGreater ? (
		<OverlayShowSizesButton className={styles.actionButton} />
	) : (
		<OverlaySizesSheetButton className={styles.actionButton} />
	)
}
